<template>
  <base-row v-bind="$props">
    <td>
      <Link
        v-if="hasRoute"
        :href="packageShowRoute"
        class="uppercase font-semibold text-blue-600 hover:underline hover:text-blue-600"
      >
        {{ item.name || 'Not named' }}
      </Link>
      <span
        v-else
        class="text-blue-600 hover:text-blue-600 hover:underline"
      >
        {{ item.name || 'Not named' }}
      </span>
    </td>
    <td>
      {{ item.batch_num }}
    </td>
    <td>
      {{ item.tag_num }}
    </td>
    <td>
      {{ item.lot_num }}
    </td>
    <td>
      {{ item.quantity }}
    </td>
    <td>
      {{ item.published_at ? _date(item.published_at) : '-' }}
    </td>
    <!--        <td>-->
    <!--            <button type="button" class="btn btn-secondary-outline" @click="$emit('inspect')">Inspect</button>-->
    <!--        </td>-->
    <td>
      <basic-badge
        v-if="item.published_at"
        color="green"
      >
        Published
      </basic-badge>
      <basic-badge
        v-else
        color="gray"
      >
        Un-published
      </basic-badge>
    </td>
  </base-row>
</template>

<script>
import { Link } from '@inertiajs/vue3'
import TableRow from '@/Components/Table/TableRow'
import RowProps from '@/Components/Table/Mixins/RowProps'
import BasicBadge from '@/Components/Badges/BasicBadge.vue'
import _date from '@/Filters/Date'
import _percent from '@/Filters/Percent'

export default {
  components: {
    'base-row': TableRow,
    Link,
    BasicBadge
  },

  mixins: [RowProps],

  props: {
    /**
     * A function that we can use to generate the URL to view a package. Returns a string that is a valid URL
     */
    showRoute: {
      type: Function,
      default: (item) => null
    }
  },

  computed: {
    /**
     * @returns String
     */
    status() {
      return this?.item?.published_at ? 'Published' : 'Un-published'
    },

    /**
     * Returns the name of the transfer location. Example: 'Maryland Health & Wellness'
     * @returns String
     */
    location() {
      return this?.item?.location?.name || 'N/A'
    },

    /**
     * Returns the URL we can use to view a package
     */
    packageShowRoute() {
      return this.showRoute(this.item)
    },

    /**
     * Returns true if this package has a valid URL to view a package
     * @returns {boolean}
     */
    hasRoute() {
      return this.packageShowRoute !== null
    }
  },

  methods: {
    _date,
    _percent
  }
}
</script>
